import auth from '../authentication';
import Vue from '../main';

export default {
    //Type Section
    getReason(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/donation-reason/get-all', data)
            .then(response => {
                context.error = false;
                context.reasons = response.data.data;
                context.total = response.data.total;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },

    createReason(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/donation-reason/add-new', data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.reason = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    getReasonDetail(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/donation-reason/get-detail/' + id)
            .then(response => {
                context.error = false;
                context.reason = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                callback(context);
            })
    },
    updateReason(context, id, data, callback) {
        Vue.http.post(Vue.apiUrl + '/donation-reason/update-detail/' + id, data)
            .then(response => {
                context.error = false;
                context.success = true;
                context.reason = response.data.data;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                context.message = response.data.message;
                callback(context);
            })
    },
    removeReason(context, id, callback) {
        Vue.http.post(Vue.apiUrl + '/donation-reason/remove/' + id, {})
            .then(response => {
                context.error = false;
                context.success = true;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.success = false;
                callback(context);
            })
    }
};